// import actionHelpers from '../../utils/action-helpers';
import getterHelpers from '../../utils/getter-helpers';
import mutationHelpers from '../../utils/mutation-helpers';
import axios from 'axios';
const path = process.env.VUE_APP_ROOT_API;

const state = {
  status: null,
  items: [],
  errors: []
};

// getters
const getters = {
  getByPonyId: state => ponyId => {
    return state.items.filter(o => {
      return (
        o.item_id === parseInt(ponyId, 10) &&
        o.item_type === 'App\\Models\\Pony'
      );
    });
  },
  getPonyComments: state => () => {
    return state.items.filter(o => {
      return o.item_type === 'App\\Models\\Pony';
    });
  }
};

// actions
const actions = {
  FETCH: async ({ commit, dispatch }, { slug }) => {
    try {
      const {
        data: {
          data: { items }
        }
      } = await axios.get(`${path}/api/pony/${slug}/comments`);

      return items;
    } catch (error) {
      commit('SET_ERROR', error);
      dispatch(
        'notification/ERROR_NOTIFICATION',
        'could not fetch comments for this pony. try again later.',
        { root: true }
      );
    }
  },
  ADD: ({ commit }, payload) => {
    // add new comment to db
    commit('ADD', [payload]);
  },
  // UPDATE: async ({ commit, dispatch }, payload) => {
  //   actionHelpers.UPDATE(`${path}/api/brand/${payload.id}`)(
  //     { commit, dispatch },
  //     payload
  //   );
  // },
  // REMOVE: async ({ commit, dispatch }, payload) => {
  //   actionHelpers.REMOVE(`${path}/api/brand/${payload.id}`)(
  //     { commit, dispatch },
  //     payload
  //   );
  // },
  SET_ERROR: ({ commit }, payload) => {
    commit('SET_ERROR', payload.errors);
  }
};

// mutations
const mutations = {
  ADD: (state, data) => {
    state.items = data.concat(state.items);
  },
  UPDATE_STATUS: mutationHelpers.UPDATE_STATUS,
  RESET_ERRORS: mutationHelpers.RESET_ERRORS,
  SET_ERROR: mutationHelpers.SET_ERROR
};

export default {
  namespaced: true,
  state,
  getters: { ...getterHelpers, ...getters },
  actions,
  mutations
};
